module.exports = __webpack_public_path__ + "img/ia.8e033d65.svg";